export const numberRoundToPrecision = (number: number, precision: number): number => {
  const divider = Math.pow(10, precision);
  return Math.round(number * divider) / divider;
};
